import React from 'react';
import FriscoUpload from './FriscoUploadComponent';
import FriscoUploadComponent from './FriscoUploadComponent';

export default (props) => {
    return <FriscoUploadComponent location={props.location} />;
}
